var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h-m-styled-plaintext',{staticClass:"mb-3",attrs:{"name":"display-choice","nav-choices":_vm.displayOptions},model:{value:(_vm.currentDisplay),callback:function ($$v) {_vm.currentDisplay=$$v},expression:"currentDisplay"}}),_c('svg',{ref:"gantt"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }